"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationStatus = void 0;
var OperationStatus;
(function (OperationStatus) {
    OperationStatus["PreparingTransaction"] = "preparing-transaction";
    OperationStatus["PreparingUserOperation"] = "preparing-user-operation";
    OperationStatus["SendingTransaction"] = "sending-transaction";
    OperationStatus["SendingUserOperation"] = "sending-user-operation";
    OperationStatus["WaitingForUserOperation"] = "waiting-for-user-operation";
    OperationStatus["GettingContractAddress"] = "getting-contract-address";
})(OperationStatus || (exports.OperationStatus = OperationStatus = {}));
